
import Vue from 'vue'

const actions = {

    async List() {

        try {
            const result = await Vue.prototype.$spTechApi.get("comum/transportadora/list-transportadoras",
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                let listTransportadoras = result.data.result;

                return listTransportadoras;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Erro ao carregar transportadoras: [${ex}]`
            };
        }
    },
}

export default {
    namespaced: true,
    actions
}
